import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa8efa32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://c4e.io/faq/",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "FAQ")
], -1 /* HOISTED */))
const _hoisted_3 = {
  href: "https://docs.c4e.io/usersGuide/walletBasics.html",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("a", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('FOOTER.HELP')), 1 /* TEXT */)
    ]),
    _createVNode(_component_router_link, { to: "/terms_conditions" }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('FOOTER.TERMS')), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_router_link, { to: "/privacy_policy" }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('FOOTER.PRIVACY')), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode($setup["TopMenu"])
  ]))
}